import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance.tsx";

export class MeetingApiService {
    private readonly meetingBaseUrl: string;

    constructor() {
        this.meetingBaseUrl = ApiConstants().meeting;
    }

    async sendFeelingAfter(meetingId: string, json: string): Promise<AxiosResponse> {
        const response = await request({
            method: "POST",
            url: `${this.meetingBaseUrl}feeling-after/${meetingId}`,
            data: json,
            headers: {
                'Content-Type': 'application/json',
            },
            requiresToken: true,
        });
        return response;
    }

    async getMeetingById(meetingId: string): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.meetingBaseUrl}${meetingId}`,
            requiresToken: true,
        });
        return response;
    }
}